import { TransitionBarService } from './transition-bar.service';
import { TransitionService } from '@uirouter/angularjs';

export function transitionBarRun( $transitions: TransitionService,
                                  transitionProgressService: TransitionBarService ) {
  $transitions.onStart({}, () => {
    // transitionProgressService.barActive(true);
  });
  $transitions.onSuccess({}, () => {
    transitionProgressService.barActive(false);
  });
  $transitions.onError({}, () => {
    transitionProgressService.barActive(false);
  });
}

transitionBarRun.$inject = [
  '$transitions',
  'TransitionBarService'
];



// WEBPACK FOOTER //
// ./app/ui/transition-bar/transition-bar.run.ts